import React from 'react';
import { MultiselectSummary, SelectInput, SelectRow, SelectSummary, SwitchRow } from './SummaryPaneComponents';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { SUMMARY_LABEL_SX, SummaryField } from './SummaryPaneComponents';
import { useUserSelectors } from '../hooks';

const UserSummary = () => {
  const userSelectors = useUserSelectors();

  return (
    <>
      {userSelectors.isAnySelectorNotNullOrEmpty && (
        <>
          <Typography variant='h4'>Users Summary</Typography>
          <SwitchRow label='TCPA Opt-in Required' value={userSelectors.criteriaOfferRequiresOptIn} />
          <SwitchRow
            label='TCPA Opt-in Required Over Last Interval'
            value={userSelectors.criteriaTcpaLastOptInInterval}
          />
          <SwitchRow
            label='Brite Verify Phone Validated'
            value={userSelectors.criteriaPhoneHasBeenVerifiedWithBriteverify}
          />
          <SwitchRow
            label='Brite Verify Email Validated'
            value={userSelectors.criteriaEmailHasBeenVerifiedWithBriteverify}
          />
          <SwitchRow label='Include users in the phone BlackList' value={userSelectors.criteriaPhoneBlacklist} />
          <SwitchRow label='English Browser Language Required' value={userSelectors.englishBrowserLanguageRequired} />
          <Grid container spacing={2} sx={{ alignItems: 'start' }}>
            {userSelectors.criteriaMinAge && (
              <Grid size={2}>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Min Age</FormLabel>
                <SummaryField value={userSelectors.criteriaMinAge} />
              </Grid>
            )}
            {userSelectors.criteriaMaxAge && (
              <Grid size={2}>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Max Age</FormLabel>
                <SummaryField value={userSelectors.criteriaMaxAge} />
              </Grid>
            )}
          </Grid>
          <SelectSummary
            value={userSelectors.browserType}
            label='Exclude Browser Type'
            options={[
              { value: '', option: 'Select' },
              { value: 'Desktop', option: 'Desktop' },
              { value: 'Mobile', option: 'Mobile' },
            ]}
          />
          <SelectSummary
            value={userSelectors.criteriaExcludeGender}
            label='Exclude Gender'
            options={[
              { value: '', option: 'Select' },
              { value: 'female', option: 'Female' },
              { value: 'male', option: 'Male' },
            ]}
          />
          {userSelectors.criteriaUserDataIncludeExclude && (
            <Grid container spacing={2} sx={{ mt: 1, alignItems: 'start' }}>
              <Grid size={2}>
                <Typography variant='h5'>Required User Data</Typography>
              </Grid>
              <Grid size={2}>
                <SelectInput value={userSelectors.criteriaUserDataIncludeExclude} />
              </Grid>
              <Grid size={8}>
                <MultiselectSummary value={userSelectors.criteriaRequiredUserData} />
              </Grid>
            </Grid>
          )}
          {userSelectors.criteriaAibListIncludeExclude && (
            <Grid container spacing={2} sx={{ mt: 1, alignItems: 'start' }}>
              <Grid size={2}>
                <Typography variant='h5'>AIB List</Typography>
              </Grid>
              <Grid size={2}>
                <SelectInput value={userSelectors.criteriaAibListIncludeExclude} />
              </Grid>
              <Grid size={8}>
                <MultiselectSummary value={userSelectors.criteriaAibList} />
              </Grid>
            </Grid>
          )}
          {userSelectors.previousRegistrationConfiguration?.andOrLogic && (
            <Grid container spacing={2} sx={{ alignItems: 'start' }}>
              <Grid size={2}>
                <Typography variant='h5'>Previous Registration Required</Typography>
              </Grid>
              <Grid size={2}>
                <SummaryField
                  value={
                    userSelectors.previousRegistrationConfiguration?.andOrLogic === 'AND'
                      ? 'All entries must pass'
                      : 'Any of these entries can pass'
                  }
                  readOnly
                  disabled
                />
              </Grid>
              <Grid size='grow'>
                {userSelectors.previousRegistrationConfiguration?.previousRegistrations?.map((item, index) => (
                  <Grid container spacing={2} sx={{ alignItems: 'start' }} key={index}>
                    <Grid size={2}>
                      <SummaryField value={item?.includeExcludeAction || ''} />
                    </Grid>
                    <Grid size={3}>
                      <MultiselectSummary value={item?.domains || []} />
                    </Grid>
                    <Grid size={3}>
                      <MultiselectSummary value={item?.affiliates || []} />
                    </Grid>
                    <Grid size={2}>
                      <SummaryField value={item?.previousRegistrationsMin || ''} />
                    </Grid>
                    <Grid size={2}>
                      <SummaryField value={item?.previousRegistrationsMax || ''} />
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
          <Grid container spacing={2} sx={{ alignItems: 'start' }}>
            {userSelectors.ipqsConfiguration?.email && (
              <Grid size={3}>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>IPQS Email</FormLabel>
                <SummaryField value={userSelectors.ipqsConfiguration.email} />
              </Grid>
            )}
            {userSelectors.ipqsConfiguration?.phone && (
              <Grid size={3}>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>IPQS Phone</FormLabel>
                <SummaryField value={userSelectors.ipqsConfiguration.phone} />
              </Grid>
            )}
            {userSelectors.ipqsConfiguration?.ip && (
              <Grid size={3}>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>IPQS IP</FormLabel>
                <SummaryField value={userSelectors.ipqsConfiguration.ip} />
              </Grid>
            )}
            {userSelectors.ipqsConfiguration?.fingerprint && (
              <Grid size={3}>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>IPQS Fingerprint</FormLabel>
                <SummaryField value={userSelectors.ipqsConfiguration.fingerprint} />
              </Grid>
            )}
          </Grid>
          <SelectSummary value={userSelectors.criteriaNullSourceNewUserIncludeExclude} label='Null Source New Users' />
          {userSelectors.userIdLastDigitIncludeExclude && (
            <SelectRow label='User_ID last digit' value={userSelectors.userIdLastDigitIncludeExclude}>
              <Grid size={4}>
                <MultiselectSummary value={userSelectors.criteriaUserIdLastDigitString} />
              </Grid>
            </SelectRow>
          )}
          {userSelectors.criteriaIncludeOrExcludeDevices && (
            <SelectRow label='Device' value={userSelectors.criteriaIncludeOrExcludeDevices}>
              <Grid size={4}>
                <MultiselectSummary value={userSelectors.criteriaDevices} />
              </Grid>
            </SelectRow>
          )}

          <SelectSummary
            value={userSelectors.criteriaAnuraScore}
            label='Anura Score'
            options={[
              { value: null, option: 'Select' },
              { value: 'NONSUSPECT', option: 'Non-suspect' },
              { value: 'SUSPECT', option: 'Suspect' },
              { value: 'NOSCORE', option: 'No Score' },
            ]}
          />
          {userSelectors.criteriaIncludeOrExcludeBrowsers && (
            <SelectRow label='Browsers' value={userSelectors.criteriaIncludeOrExcludeBrowsers}>
              <Grid size={4}>
                <MultiselectSummary value={userSelectors.criteriaBrowsers} />
              </Grid>
            </SelectRow>
          )}
          {userSelectors.criteriaIncludeOrExcludeDomains && (
            <SelectRow label='What If Domain' value={userSelectors.criteriaIncludeOrExcludeDomains}>
              <Grid size={4}>
                <MultiselectSummary value={userSelectors.criteriaDomains} />
              </Grid>
            </SelectRow>
          )}
          {userSelectors.criteriaIncludeOrExcludeOperatingSystems && (
            <SelectRow label='Operating System' value={userSelectors.criteriaIncludeOrExcludeOperatingSystems}>
              {(userSelectors.criteriaIncludeOrExcludeOperatingSystems === 'Include' ||
                userSelectors.criteriaIncludeOrExcludeOperatingSystems === 'Exclude') && (
                  <Grid size={4}>
                    <MultiselectSummary value={userSelectors.criteriaOperatingSystems} />
                  </Grid>
                )}
            </SelectRow>
          )}
          {userSelectors.criteriaIncludeOrExcludeStates && (
            <SelectRow label='States' value={userSelectors.criteriaIncludeOrExcludeStates}>
              {(userSelectors.criteriaIncludeOrExcludeStates === 'Include' ||
                userSelectors.criteriaIncludeOrExcludeStates === 'Exclude') && (
                  <Grid size={4}>
                    <MultiselectSummary value={userSelectors.criteriaStates} />
                  </Grid>
                )}
            </SelectRow>
          )}
          {userSelectors.criteriaIncludeOrExcludeZips && (
            <SelectRow label='Zip Code' value={userSelectors.criteriaIncludeOrExcludeZips}>
              {(userSelectors.criteriaIncludeOrExcludeZips === 'Include' ||
                userSelectors.criteriaIncludeOrExcludeZips === 'Exclude') && (
                  <>
                    <Grid size={4}>
                      <SummaryField value={userSelectors.criteriaZips} multiline />
                    </Grid>
                    <Grid size={{ xs: 12, lg: 2 }}>
                      Count:{' '}
                      {
                        userSelectors.criteriaZips?.split(/\s+/).filter((zip) => zip.trim().length === 5 && !isNaN(zip))
                          .length
                      }
                    </Grid>
                  </>
                )}
            </SelectRow>
          )}
          {userSelectors.jobKeywords && userSelectors.jobKeywordIncludeExclude && (
            <SelectRow
              label="Job Keyword"
              value={userSelectors.jobKeywordIncludeExclude}
              options={[
                { value: 'None', option: 'None' },
                { value: 'Include', option: 'Include' },
                { value: 'Exclude', option: 'Exclude' },
              ]}
              disabled
            >
              {(userSelectors.jobKeywordIncludeExclude === 'Include' ||
                userSelectors.jobKeywordIncludeExclude === 'Exclude') && (
                  <>
                    <Grid size={{ xs: 12, lg: 4 }}>
                      <SummaryField value={userSelectors.jobKeywords} multiline />
                    </Grid>
                  </>
                )}
            </SelectRow>
          )}
        </>
      )}
    </>
  );
};

export default UserSummary;
